<cmi-parameter-value-editor [parameterName]="groupName()" [parameterType]="parameterType()" />
